import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [flags, setFlags] = useState({});

  useEffect(() => {
    api.get("/feature-flags").then(({ data }) => setFlags(data.flags || {})).catch(() => {});
  }, []);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("mj_token");
    if (!t) {
      setUser(null);
      setProfile(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setProfile(data.profile);
    } catch {
      localStorage.removeItem("mj_token");
      setUser(null);
      setProfile(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const loginWithToken = async (tok, u) => {
    localStorage.setItem("mj_token", tok);
    setUser(u);
    await refresh();
  };

  const logout = () => {
    localStorage.removeItem("mj_token");
    setUser(null);
    setProfile(null);
  };

  return (
    <AuthCtx.Provider value={{ user, profile, loading, flags, refresh, loginWithToken, logout, setProfile, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
